<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="供应链名称">
        <el-input v-model="queryForm.supplierName"></el-input>
      </el-form-item>
      <el-form-item label="供应链电话">
        <el-input v-model="queryForm.supplierPhone"></el-input>
      </el-form-item>
      <el-form-item label="社会唯一信用码">
        <el-input v-model="queryForm.uscc"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getBrandList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            :disabled="multipleSelection.length > 0"
            @click="addShopBrand(1)"
          >新建</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteShopBrand(null)"
          >删除</el-button>
        </div>

        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshShopBrandList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopScmSupplierList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="10%"
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="supplierName"
          label="供应链名称"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="uscc"
          label="社会唯一信用码"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="supplierPerson"
          label="供应链负责人"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="supplierPhone"
          label="供应链电话"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="supplierAddress"
          label="供应链地址"
          min-width="20%"
        >
        </el-table-column>
        
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="20%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopBrand(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopBrand(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopBrand(scop.row.id)">
                <Icon
                  size="16"
                  style="color: red"
                >
                  <Delete24Regular />
                </Icon>
                <span
                  class="operation-label"
                  style="color: red"
                >删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog
        :title="shopBrandStates[shopBrandState]"
        :visible.sync="showDialog"
        width="400px"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="shopScmSupplier"
            ref="shopScmSupplierForm"
            :rules="rules"
            label-width="80px"
            :inline="true"
            size="small"
          >
            <el-form-item
              label="供应链名称"
              prop="supplierName"
            >
              <el-input
                size="small"
                style="width: 180px"
                v-model="shopScmSupplier.supplierName"
                :disabled="shopBrandState == 'check'"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="社会唯一信用码"
              prop="uscc"
            >
              <el-input
                size="small"
                style="width: 180px"
                v-model="shopScmSupplier.uscc"
                :disabled="shopBrandState == 'check'"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="供应链负责人"
              prop="supplierPerson"
            >
              <el-input
                size="small"
                style="width: 180px"
                v-model="shopScmSupplier.supplierPerson"
                :disabled="shopBrandState == 'check'"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="供应链电话"
              prop="supplierPhone"
            >
              <el-input
                size="small"
                style="width: 180px"
                v-model="shopScmSupplier.supplierPhone"
                :disabled="shopBrandState == 'check'"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="供应链地址"
              prop="supplierAddress"
            >
              <el-input
                size="small"
                style="width: 180px"
                v-model="shopScmSupplier.supplierAddress"
                :disabled="shopBrandState == 'check'"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="shopBrandState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post, deleteFun, upload } from '@/utils/request.js';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopBrandList();
                this.getBrandList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopBrandList();
                this.getBrandList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                supplierName: '',
                uscc: '',
                supplierPerson: '',
                supplierPhone: '',
                supplierAddress: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentShopBrandId: '',
            shopBrandState: 'add',
            shopBrandStates: {
                add: '新建供应链',
                check: '查看供应链',
                edit: '修改供应链'
            },
            multipleSelection: [],
            shopScmSupplierList: [],
            shopScmSupplier: {
                supplierName: '',
                uscc: '',
                supplierPerson: '',
                supplierPhone: '',
                supplierAddress: ''
                
            },
            btnLoading: false,
            status: '', //1 :用户 2 ：职位
            rules: {
                supplierName: [{ required: true, message: '供应链名称不能为空', trigger: 'blur' }],
                uscc: [{ required: true, message: '社会唯一信用码不能为空', trigger: 'blur' }],
                supplierPerson: [{ required: true, message: '供应链负责人不能为空', trigger: 'blur' }],
                supplierPhone: [{ required: true, message: '供应链电话不能为空', trigger: 'blur' }],
                supplierAddress: [{ required: true, message: '供应链地址不能为空', trigger: 'blur' }]
            },
   
        };
    },
    created() {
        this.getBrandList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopScmSupplierList = [];
        },
        resetDialog() {
            this.shopBrandState = 'add';
            this.showDialog = false;
            this.shopScmSupplier = {
                supplierName: '',
                uscc: '',
                supplierPerson: '',
                supplierPhone: '',
                supplierAddress: ''
            };
            this.getBrandList();
        },
        closeDialog() {
            this.resetDialog();
            this.$refs.shopScmSupplierForm.resetFields();
        },
        submitForm() {
            if (this.shopBrandState == 'add') {
                this.$refs.shopScmSupplierForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/shopScmSupplier/add`, { ...this.shopScmSupplier }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopBrandList();
                                this.closeDialog();
                            }
                        });
                    }
                });
            } else if (this.shopBrandState == 'edit') {
                this.$refs.shopScmSupplierForm.validate((valid) => {
                    if (valid) {
                      console.log("*************>",this.shopScmSupplier)
                        post(`/shop/shopScmSupplier/edit`, { ...this.shopScmSupplier }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopBrandList();
                                this.closeDialog();
                            }
                        });
                    }
                });
            }
        },

        addShopBrand(value) {
            this.showDialog = true;
            this.status = value;
            this.shopBrandState = 'add';
        },
        checkShopBrand(shopBrandId) {
            this.currentShopBrandId = shopBrandId;
            this.getShopBrandById();
            this.showDialog = true;
            this.shopBrandState = 'check';
        },
        editShopBrand(shopBrandId) {
            console.log('shopScmSupplier', shopBrandId);
            if (shopBrandId) {
                this.currentShopBrandId = shopBrandId;
                this.getShopBrandById();
            } else {
                this.shopScmSupplier = { ...this.shopBshopScmSupplierrand, ...this.multipleSelection[0] };
            }
            this.showDialog = true;
            this.shopBrandState = 'edit';
        },
        deleteShopBrand(shopBrandId) {
            let ids = '';
            if (shopBrandId) {
                ids = shopBrandId;
            } else {
                ids = this.multipleSelection.map((shopScmSupplier) => shopScmSupplier.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/shopScmSupplier/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopBrandList();
                            this.getBrandList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopBrandList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        getBrandList() {
            this.loading = true;
            get(`/shop/shopScmSupplier/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopScmSupplierList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        resetQueryFrom() {
            this.queryForm.supplierName = '';
            this.getBrandList();
        },
        getShopBrandById() {
            console.log('this.currentShopBrandId',this.currentShopBrandId);
            get(`/shop/shopScmSupplier/get`, { id: this.currentShopBrandId }).then((res) => {
                if (res.success) {
                    this.shopScmSupplier = { ...this.shopScmSupplier, ...res.shopScmSupplier };
                }
            });
        },
      
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        }
    }
};
</script>

<style lang="scss" scoped>

.page-content{
    height: 100%;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
